import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReportContractFinancialState {
  collectionContractFinancial: any[];
  paymentContractFinancial: any[];
  balanceContractFinancial: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ReportContractFinancialState = {
  collectionContractFinancial: [],
  paymentContractFinancial: [],
  balanceContractFinancial: [],
  isLoading: false,
  error: null,
};

const reportContractFinancialSlice = createSlice({
  name: 'reportContractFinancial',
  initialState,
  reducers: {
    setCollectionContractFinancial: (state, action: PayloadAction<any[]>) => {
      state.collectionContractFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setPaymentContractFinancial: (state, action: PayloadAction<any[]>) => {
      state.paymentContractFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setBalanceContractFinancial: (state, action: PayloadAction<any[]>) => {
      state.balanceContractFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setReportContractFinancialLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    setReportContractFinancialError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setCollectionContractFinancial,
  setPaymentContractFinancial,
  setBalanceContractFinancial,
  setReportContractFinancialLoading,
  setReportContractFinancialError,
} = reportContractFinancialSlice.actions;

export default reportContractFinancialSlice.reducer;
